import React from "react";
import { useHistory } from "react-router-dom";

import {
  Context,
  fetchActiveLearningMaterials,
  activeLearningGuidelinePath,
  activeLearningProjectionPath,
  textbookPath,
  chooseTextbookPath,
} from "../../../teacherStore";
import ActiveLearningSelectPage from "../../../templates/teacher/ActiveLearningSelectPage";
import { parseQueryParams } from "../../../libs/Util";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling] = useWaitApiCall(state);
  const history = useHistory();
  const classListInParams = parseQueryParams()["classList"];
  const classList = React.useMemo(
    () =>
      classListInParams
        ? classListInParams.split(",").map((classID: string) => Number(classID))
        : null,
    [classListInParams],
  );
  if (state.available_item_codes.length === 0) {
    const path = `${textbookPath}${chooseTextbookPath}`;
    history.push(path);
    return null;
  }

  React.useEffect(() => {
    dispatch(fetchActiveLearningMaterials());
    // return () => dispatch(clearTeachingMaterials());
  }, [dispatch]);

  const openGuideline = React.useCallback(
    (teaching_material_id: string, id: number) => {
      history.push({
        pathname: `${activeLearningGuidelinePath}/${teaching_material_id}`,
        search: `?lesson=${id}&page=1&classList=${classList}`,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history],
  );

  const openProjection = React.useCallback(
    (teaching_material_id: string, id: number) => {
      window.open(
        `${activeLearningProjectionPath}/${teaching_material_id}?lesson=${id}&page=1&classList=${classList}`,
        "_blank",
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [classList],
  );

  return (
    <ActiveLearningSelectPage
      active_learning_materials={state.active_learning_materials}
      calling={calling}
      openGuideline={openGuideline}
      openProjection={openProjection}
      availableItemCodes={state.available_item_codes}
    />
  );
};
